import logo_capifrance from '../../assets/img/brand/logo-capifrance-blanc.png';
import logo_digitregroup from '../../assets/img/brand/logo-digit-h-blanc.png';
import logo_digital_factory from '../../assets/img/brand/logo-digital-factory-black.png';
import logo_dili from '../../assets/img/brand/logo-dili-thumbnail.png';
import logo_refleximmo from '../../assets/img/brand/logo-reflex-white.svg';
import logo_optimhome from '../../assets/img/brand/logo_optimhome_2023.svg';

/**
 * Common app service
 */
export default class App {
  static logos = {
    DIGITAL_FACTORY: logo_digital_factory,
    DIGITREGROUP: logo_digitregroup,
    CAPIFRANCE: logo_capifrance,
    OPTIMHOME: logo_optimhome,
    REFLEXIMMO: logo_refleximmo,
    DILI: logo_dili,
  };

  static defaultLogo = 'DIGITREGROUP';

  /**
   * Return the application logo relating to the company
   * @param {string} companyCode User company code
   * @returns {*} Company logo
   */
  static getCompanyAppLogo(companyCode) {
    if (!companyCode || !App.logos[companyCode]) {
      return App.logos[App.defaultLogo];
    }

    return App.logos[companyCode];
  }
}
